import { QAState, IScoreDetails, CalibrationStatus } from "./qa.state";
import AnyAction from "store/anyActions";
import { QATypes } from "./qa.types";

const defaultState: QAState = {
    showNewScoreForm: false,
    unreadScoresCount: 0,
}

export default function (state: QAState = defaultState, action: AnyAction): QAState {
    switch (action.type) {
        case QATypes.SEARCH_SCORES:
            return { ...state, scores: action.payload, searchScoresLoading: false };
        case QATypes.SEARCH_SCORES_LOADING:
            return { ...state, searchScoresLoading: true };
        case QATypes.SEARCH_SCORES_ERROR:
            return { ...state, searchScoresError: true, searchScoresLoading: false };
        case QATypes.SEARCH_CALIBRATIONS:
            return { ...state, calibrations: action.payload, searchCalibrationsError: false, searchCalibrationsLoading: false }
        case QATypes.SEARCH_CALIBRATIONS_LOADING:
            return { ...state, searchCalibrationsLoading: true }
        case QATypes.SEARCH_CALIBRATIONS_ERROR:
            return { ...state, searchCalibrationsError: true }
        case QATypes.START_CALIBRATION:
            return { ...state, scores: state.scores?.map(s => {
                if (s.ID !== action.payload.scoreID) return s;

                return {
                    ...s,
                    calibrationStatus: CalibrationStatus.IN_PROGRESS
                }
            })}
        case QATypes.SET_CURRENTLY_CALIBRATING:
            return { ...state, currentScore: action.payload.score as IScoreDetails }
        case QATypes.CHANGE_CALIBRATION_STATUS:
            return { 
                ...state,
                calibrationsBusy: undefined,
                calibrations: state.calibrations?.map(c => {
                    if (c.ID !== action.payload.ID) return c;

                    return {
                        ...c,
                        calibrationStatus: action.payload.calibrationStatus
                    }

                }),
                currentCalibration: state.currentCalibration?.ID === action.payload.ID
                    ? { ...state.currentCalibration, calibrationStatus: action.payload.calibrationStatus }
                    : state.currentCalibration
            }
        case QATypes.GET_FULL_CALIBRATION:
            return { ...state, currentCalibration: action.payload, calibrationsBusy: undefined };
        case QATypes.CLEAR_CALIBRATION:
            return { ...state, currentCalibration: undefined };
        case QATypes.CALIBRATION_BUSY:
            return { ...state, calibrationsBusy: action.payload}
        case QATypes.GET_SCORE:
            return { ...state, currentScore: action.payload, getScoreLoading: "" };
        case QATypes.GET_SCORE_LOADING:
            return { ...state, getScoreLoading: action.payload };
        case QATypes.CLEAR_SCORE:
            return { ...state, currentScore: undefined };
        case QATypes.UPDATE_SCORE:
            return {
                ...state,
                updateScoreLoading: false,
                scoreCalculating: false,
                currentScore: {
                    ...state.currentScore,
                    ...action.payload
                },
                scores: state.scores?.map(s => {
                    if (s.ID !== action.payload.ID) return s;

                    return {
                        ...s,
                        ...action.payload
                    }
                })
            }
        case QATypes.UPDATE_SCORE_LOADING:
            return { ...state, updateScoreLoading: true }
        case QATypes.NEW_SCORE:
            return {
                ...state,
                updateScoreLoading: false,
                scoreCalculating: false,
                currentScore: {
                    ...state.currentScore,
                    ...action.payload.newScore,
                    contact: action.payload.contact
                },
                creatingScore:false,
                showNewScoreForm: false
            }
        case QATypes.CREATING_SCORE:
            return { ...state, creatingScore: true };
        case QATypes.SCORE_CALCULATE:
            return { ...state, scoreCalculating: action.payload }
        case QATypes.DELETE_SCORE:
            return {
                ...state,
                deleteScoreLoading: false,
                deletingScore: "",
                scores: state.scores?.filter(s => s.ID !== action.payload),
                currentScore: state.currentScore?.ID !== action.payload ? state.currentScore : undefined
            }
        case QATypes.DELETE_SCORE_LOADING:
            return { ...state, deleteScoreLoading: true };
        case QATypes.DELETING_SCORE:
            return { ...state, deletingScore: action.payload };
        case QATypes.SET_SCORE_SEARCH_PARAMS:
            return { ...state, scoreSearchParams: action.payload }
        case QATypes.SET_SHOW_NEW_SCORE:
            return { ...state, showNewScoreForm: action.payload }
        case QATypes.GET_MY_SCORES:
            return { ...state, myScores: action.payload, myScoresLoading: false, myScoresError: false }
        case QATypes.MY_SCORES_LOADING:
            return { ...state, myScoresLoading: true, myScoresError: false }
        case QATypes.MY_SCORES_ERROR:
            return { ...state, myScoresLoading: false, myScoresError: true }
        case QATypes.GET_QA_TEMPLATES:
            return {...state, qaTemplates: action.payload }
        case QATypes.CREATE_QA_TEMPLATE:
        case QATypes.EDIT_QA_TEMPLATE:
        case QATypes.DELETE_QA_TEMPLATE:
            return {...state, qaTemplates: undefined }
        case QATypes.GET_EVALUATION_CONFIG_LOADING:
            return {
                ...state,
                evaluationConfig: {
                    evaluationConfigLoading: action.payload.loading,
                    config: {channel: [], customerJourney: []},
                    evaluationConfigError: false,
                },
            };

        case QATypes.GET_EVALUATION_CONFIG:
            return {
                ...state,
                evaluationConfig: {
                    evaluationConfigLoading: false,
                    config: action.payload,
                    evaluationConfigError: false,
                },
            };

        case QATypes.GET_EVALUATION_CONFIG_ERROR:
            return {
                ...state,
                evaluationConfig: {
                    evaluationConfigLoading: false,
                    config: {channel: [], customerJourney: []},
                    evaluationConfigError: action.payload.error,
                },
            };

        case QATypes.GET_UNREAD_SCORES_COUNT:
            return {
                ...state,
                unreadScoresCount: action.payload.unreadScoresCount,
            }

        case QATypes.SET_UNREAD_SCORES_COUNT:
            return {
                ...state,
                unreadScoresCount: action.payload.unreadScoresCount,
            }
        default:
            return state;
    }

}